import * as R from 'ramda'
import _ from 'lodash'
import { SET_SURVEY_FROM_ID, SET_SURVEY_LIST, HAS_NO_SURVEY_ACCESS, SET_SURVEY_DATA } from 'actions'
import { SET_ENTITIES } from '../../actions/sync'

const initialState = {
  // TODO rename this to entities
  entity: {},
  allIds: [],
  loading: true,
}

const surveys = (state = initialState, action) => {
  switch (action.type) {
    case SET_SURVEY_FROM_ID:
      return R.mergeDeepRight(state, {
        entity: { [action.survey.id]: action.survey },
      })
    case SET_SURVEY_LIST: {
      const getId = (obj) => obj.survey.id
      const getEntity = (obj) => obj.survey

      return R.mergeDeepRight(state, {
        allIds: R.map(getId, action.surveyList),
        entity: R.merge(
          _.keyBy(R.map(getEntity, action.surveyList), 'id'),
          _.keyBy(R.map(getEntity, action.surveyList), 'token')
        ),
        loading: false,
      })
    }
    case HAS_NO_SURVEY_ACCESS: {
      return R.mergeDeepRight(state, {
        loading: false,
      })
    }
    case SET_SURVEY_DATA: {
      return R.mergeDeepRight(state, {
        allIds: R.append(action.surveyData.id, state.allIds),
        entity: { [action.surveyData.id]: action.surveyData },
      })
    }
    case SET_ENTITIES: {
      return R.mergeDeepRight(state, {
        allIds: R.propOr(state.allIds, 'surveys', action.allIds),
        entity: R.merge(
          R.propOr(state.entity, 'surveys', action.entities),
          _.keyBy(R.map(R.identity, R.propOr(state.entity, 'surveys', action.entities)), 'token')
        ),
      })
    }
    default:
      return state
  }
}

export default surveys

export const getIsSatisfactionRatingBackwardSyncActive = (state, surveyId) =>
  R.path(['settings', 'addSatisfaction', 'isActive'], state.entity[surveyId])

export const getSurveySettingsFromId = (state, surveyId) =>
  R.path(['settings'], state.entity[surveyId])

export const getSurveyFromId = (state, surveyId) => state.entity[surveyId]

// TODO send id from backend
export const getSurveyNameFromToken = (state, surveyToken) =>
  R.path(['name'], getSurveyFromToken(state, surveyToken))

export const getSurveyFromToken = (state, surveyToken) =>
  state.allIds.map((id) => state.entity[id]).filter((survey) => survey.token === surveyToken)[0]

export const getSurveyTokenFromId = (state, surveyId) => R.path([surveyId, 'token'], state.entity)

export const getSurveyTypeFromId = (state, surveyId) => R.path([surveyId, 'type'], state.entity)

export const hasSurveyByType = (state, surveyType) =>
  R.any((item) => item.type === surveyType, R.values(state.entity))

export const getAllSurveys = (state) => state.allIds.map((id) => state.entity[id])



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/surveys.js